<template>
  <el-card>
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{name: 'moderation'}">Abuse Reports</el-breadcrumb-item>
        <el-breadcrumb-item>Report on {{ report['data_name'] }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group class="card-toolbar">
        <el-button type="primary" size="mini" @click="preview()">
          <i class="fa fa-eye" aria-hidden="true"></i> View in MotoCompano
        </el-button>
        <el-button type="primary" size="mini">
          <i class="fa fa-download" aria-hidden="true"></i>
        </el-button>
        <el-button type="primary" icon="fa fa-trash" size="mini"></el-button>
      </el-button-group>
    </div>
    <div class="report-subject">
      <h3>Subject of the Report</h3>
      <p><span>Type</span>{{ report.type }}</p>
      <p><span>ID</span>{{ report.data_name }}</p>
      <p>
        <span>Owner</span>
        <el-button type="text" @click="navigateToUser(report.owner)">
          {{ report.owner_name }}
        </el-button>
      </p>
    </div>
    <h4>
      Report from {{ asDate(report['ctime']) }} by
      <el-button type="text" @click="navigateToUser(report.reporter)">
        user {{ report.reporter }}
      </el-button>
    </h4>
    <p>{{ report.comment }}</p>
    <h4>Other reports on this subject:</h4>
    <div v-for="other in otherReports" class="other-report">
      <h5>
        {{ asDate(other.ctime) }} by
        <el-button type="text" @click="navigateToUser(other.reporter)">
          user {{ other.reporter }}
        </el-button>
      </h5>
      <p>{{ other.comment }}</p>
    </div>
  </el-card>
</template>

<style lang="scss">
.report-subject {
  margin-bottom: 20px;

  & > p {
    margin: 0;

    button {
      padding: 0;
    }

    & > span {
      float: left;
      width: 120px;
    }
  }
}
.other-report {
  border-left: 1px solid #8492A6;
  padding-left: 20px;
}
</style>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import filter from 'lodash/filter'
import axios from 'axios'

const API_URL = process.env.API_URL

export default {
  data: function () {
    return {
      previewLink: '',
      others: []
    }
  },

  computed: {
    otherReports () {
      const dataName = this.report.data_name
      const id = this.report.id
      return filter(this.reportEntities, (o) => {
        return o.data_name === dataName && o.id !== id
      })
    },
    ...mapGetters('abuseReports', {
      report: 'selected'
    }),
    ...mapState('abuseReports', {
      reportEntities: state => state.entities
    })
  },

  methods: {
    asDate (value) {
      return moment(value).format('lll')
    },
    navigateToUser (id) {
      this.$router.push({ name: 'user', params: { id: id } })
    },
    preview () {
      window.open(this.previewLink, '_blank')
    }
  },

  created () {
    axios.get(API_URL + '/ghostmode', {
      params: {
        type: this.report.type,
        id: this.report.data_name
      }
    }).then((response) => {
      this.previewLink = response.data.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/moderation/AbuseReport.vue